/**
 * Created by Lauta on 16/9/2019.
 */

export class PageState {

    public url: string = null;
    public state: any = {};
}


// WEBPACK FOOTER //
// ./src/app/core/domain/page-state.ts